import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Checkbox, Tooltip} from 'antd';
import BaseComponent from '../../../../../base/BaseComponent';
import moment from "moment";
import {formatSecondsFont, unitConvert} from "../../../../../utils";
import lock from "../../resourcePool/img/smallLock.png";


export default class Audio extends BaseComponent {
    static defaultProps = {
        checked: false,
        title: 'aaaddd',
        size: '0',
        timeRanges: '0',
        img: 'images/fileLibrary/icon_mp3_3.png',
        onClick: () => {
            console.log("点击");
        },
        IsChecked:()=>{

        }
    };
    static propTypes = {
        title: PropTypes.string.isRequired,//传入dom 结构
        size: PropTypes.string.isRequired,//文件大小
        timeRanges:PropTypes.string.isRequired,//时间范围
        onClick: PropTypes.func.isRequired,//双击函数
        IsChecked: PropTypes.func.isRequired,//选中的函数
        img:PropTypes.string.isRequired,//传入图标
    };

    constructor(props) {
        super(props);
        this.state = {
            hover: false
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }
    handleEnter() {
        this.setState({hover: true})
    }

    handleOut() {
        this.setState({hover: false})
    }
    render() {
        // 鼠标划过
        let isHover;
        if(this.props.checked){
            isHover ='block'
        }else{
            isHover ='none';
            if(this.state.hover){
                isHover ='block'
            }else{
                isHover ='none'
            }
        }

        return (
            <div>
                {this.renderFileCard(isHover)}
            </div>)
    }

    renderFileCard(isHover) {
        let size = this.props.file['size']
        return (

            <div style={{ width: '132px', height: '132px', background: 'rgba(0, 80, 179, 0.04)', borderRadius: '2px', position: 'relative',  }}
                 onMouseOver ={() => this.handleEnter()}
                 onMouseOut= {() => this.handleOut()}
                >
                <img src={this.props.file['icon']} style={{width: '56px', height: '60px',objectFit: 'contain', marginTop:'16px',marginLeft:'38px', marginBottom:'4px',cursor: "pointer"}} onClick={() => {
                    this.props.onClick()
                }}></img>
                {this.props.IsDownLoad? <img src={lock} onClick={()=>{
                   this.props.applyDownload&&this.props.applyDownload()
                }}  style={{
                    position:'absolute',
                    top:5,
                    left:7,
                    zIndex:1,
                    fontSize:'16px',
                    color:'#ffffff'}}/>:null}
                <div style={{height:"36px", textAlign:'center',lineHeight:'18px'}}>
                        <div className={'twoText'} style={{fontSize: '14px',overflow: 'hidden',textOverflow: 'ellipsis',color: "rgba(0, 0, 0, 0.65)"}} title={this.props.file['name'] || ""}>{this.props.file['name'] || ""}</div>
                    <div style={{fontSize: '12px', color: "rgba(0, 0, 0, 0.45"}}>{size?unitConvert(size):'0B'}</div>
                 </div>
                 <div style={{minWidth:'59px',
                 height:'20px',
                 textAlign:'center',
                 lineHeight:'20px',
                 position:'absolute',
                 top:'0',right:'0',
                 backgroundColor:'rgba(0, 0, 0, 0.4)',
                 borderRadius:'0px 2px 0px 0px',
                 color:'rgba(255, 255, 255, 1)',
                 fontSize:'10px'}}>
                     {this.props.file['duration']?formatSecondsFont(this.props.file['duration']/1000):"00分00秒"}
                 </div>
                <div style={{width:35,height:35,display: isHover, position: 'absolute', right: 0, top: 0,zIndex:1,cursor: "pointer"}}
                     onClick={() => {
                         this.props.IsChecked && this.props.IsChecked(!this.props.checked)
                     }}>
                    <Checkbox  checked={this.props.checked} style={{marginLeft:10,marginTop:5}}>
                    </Checkbox>
                </div>
            </div>
        )
    }

}
